import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  autocomplete: "off",
  class: "flex flex-col gap-3"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-6" }
const _hoisted_3 = { class: "sm:col-span-5" }
const _hoisted_4 = { class: "block text-sm font-medium text-gray-800" }
const _hoisted_5 = { class: "mt-4 grid grid-cols-2 place-content-around gap-4" }

import { Ref, ref, watch, onMounted } from 'vue';

import { useRealtimeReportStore } from '@/stores';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';

import { RealtimeReportFilter, SelectOptionsServiceGetQueuesResult } from '@/types';

import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'RealtimeReportFilters',
  setup(__props) {

const filterOpened = ref(false);
const realtimeReportStore = useRealtimeReportStore();

const filters: Ref<RealtimeReportFilter> = ref({
    queues: realtimeReportStore.defaultFilter.queues,
});

watch(filterOpened, () => {
    refreshLocalFilter();
});

const queueOptions = ref<SelectOptionsServiceGetQueuesResult[]>([]);
const fetchQueues = async () => {
    try {
        const { data } = await SelectOptionsService.getQueues();
        queueOptions.value = data;
    } catch (error) {
        toastServiceError(error);
    }
};

const applyFilters = () => {
    realtimeReportStore.applyFilters(filters.value);
};

const clearFilters = () => {
    realtimeReportStore.clearFilter();
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filters.value.queues = realtimeReportStore.filter.queues;
};

onMounted(() => {
    fetchQueues();
});

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_UiRightPanel = _resolveComponent("UiRightPanel")!

  return (_openBlock(), _createBlock(_component_UiRightPanel, {
    modelValue: filterOpened.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterOpened).value = $event)),
    title: _ctx.$t('filter.sidebar.title')
  }, {
    button: _withCtx(() => [
      _createVNode(_component_UiButton, {
        size: "md",
        variant: "white",
        "text-variant": "gray-700",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpened.value = true))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterIcon), {
            class: "mr-3 h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('core.actions.Filter')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('report.realtime.filters.queue')), 1),
            _createVNode(_component_UiMultiselect, {
              name: "realtimeQueueFilter",
              options: queueOptions.value,
              modelValue: filters.value.queues,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.queues) = $event)),
              label: "name",
              "value-prop": "id",
              multiple: "",
              "can-clear": ""
            }, null, 8, ["options", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_UiButton, {
            variant: "white",
            "text-variant": "gray-700",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Clear')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_UiButton, {
            variant: "primary",
            "text-variant": "white",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (applyFilters()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Apply')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})